import axios from "axios";
import { Config } from "../config/Config";

/**
 * バックエンドAPI連携サービス
 * @param apiToken トークン
 */
export const MygruBackendService = (apiToken: string) => {
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${apiToken}`,
    "Api-Version": Config["backendApiVersion"] || "v1",
  };

  /**
   * ポイントカード初期化APIを実行
   * @param user ユーザーID
   * @param campaignId キャンペーンID
   */
  const initPointCard = async (user: string, campaignId: string) => {
    await axios.post(
      `${Config.backendBaseUrl}/api/point-cards/init`,
      { user, campaignId },
      { headers }
    );
  };

  /**
   * ポイントカード更新APIを実行
   * @param user ユーザーID
   * @param campaignId キャンペーンID
   */
  const updatePointCard = async (user: string, campaignId: string) => {
    const response = await axios.post(
      `${Config.backendBaseUrl}/api/point-cards/update`,
      { user, campaignId },
      { headers }
    );

    return response.data;
  };

  return { initPointCard, updatePointCard };
};
